// ==============================|| OVERRIDES - INPUT BASE ||============================== //

import { alpha, inputBaseClasses, outlinedInputClasses, Theme } from "@mui/material"

export default function InputBase() {
    return {
        MuiInputBase: {
            styleOverrides: {
                root: ({ theme }: { theme: Theme }) => ({
                    backgroundColor: alpha(theme.palette.secondary.main, 0.08),
                    [`& .${inputBaseClasses.input}`]: {
                        textAlign: "left",
                    },
                    [`&.${inputBaseClasses.readOnly}`]: {
                        backgroundColor: alpha(theme.palette.secondary.main, 0.05),
                    },
                    [`&.${inputBaseClasses.readOnly}.${inputBaseClasses.focused}`]: {
                        boxShadow: "none",
                    },
                    [`&.${inputBaseClasses.readOnly}.${inputBaseClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
                        {
                            borderColor: "transparent",
                        },
                    [`&.${inputBaseClasses.readOnly} .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: "transparent",
                    },
                    [`&.${inputBaseClasses.readOnly}:hover .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: "transparent",
                    },
                    [`&.${inputBaseClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
                        opacity: 0.6,
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                    },
                }),
                sizeSmall: {
                    fontSize: "0.75rem",
                },
            },
        },
    }
}
